import { z } from 'zod';

// Schéma de base partagé entre l'ajout et l'édition d'un collaborateur.
const collaboratorBaseSchema = z.object({
  firstName: z.string().trim().optional(),
  lastName: z.string().trim().min(1, 'Le nom est obligatoire'),
  email: z
    .string()
    .trim()
    .min(1, "L'email est obligatoire")
    .pipe(z.email("Format d'email invalide")),
  profileId: z.string().min(1, 'Le profil est obligatoire'),
  isActive: z.boolean().default(true),
});

// Schéma de validation du formulaire d'ajout d'un collaborateur (avec confirmation d'email)
export const collaboratorFormSchema = collaboratorBaseSchema
  .extend({
    confirmEmail: z.string().trim().min(1, "La confirmation de l'email est obligatoire"),
  })
  .refine(data => data.email === data.confirmEmail, {
    message: 'Les emails ne correspondent pas',
    path: ['confirmEmail'],
  });

export type CollaboratorFormValues = z.infer<typeof collaboratorFormSchema>;

// Dérivé pour une édition future : mêmes règles hors confirmation d'email (champ absent du formulaire d'édition).
export const editCollaboratorFormSchema = collaboratorBaseSchema;

export type EditCollaboratorFormValues = z.infer<typeof editCollaboratorFormSchema>;
